import { Component, Input, OnInit } from '@angular/core';
import { InfobarBase } from '../../../../../components/common/infobar-base/infobar-base';
import { TabConfig } from '../../../../../components/common/pollux-tab-config/pollux-form-config';
import { EventBusService } from '../../../../../services/event-bus.service';


/**
 * Infobar (sidebar)
 */
@Component({
  selector: 'project-valuation-infobar',
  templateUrl: './project-valuation-infobar.component.html'
})
export class ProjectValuationInfobarComponent extends InfobarBase implements OnInit {

  /**
  * Input main data.
  */
  @Input() main: any;

  /**
  * Mode information
  */
  mode = 'projectstd';

  /**
  * Infobar item
  */
  infobarItem = {};

  /**
  * Infobar type
  */
  infobarType = null;

  /**
  * Enable settings
  */
  enableSettings = null;

  /**
  * Constructor
  */
  constructor(private eventBus: EventBusService) {
    super();
  }


  /**
  * On init.
  */
  ngOnInit(): void {
    this.main.onInfobarCreated(this);
    //upon creation, infobar should be hidden (open on clickin an item)
    this.main.setPVInfoBarVisibility(false, true);
    this.subscribeToProjectValuationInfobarChange();
    this.subscribeToProjectValuationInfobarItemChanged();
    this.eventBus.subscribeEvent('toolbarSetArea', (newArea) => {
      this.mode = newArea;
    });
  }

  /**
   * Subscribes to infobar item change event
   * */
  subscribeToProjectValuationInfobarItemChanged() {
    this.eventBus.subscribeEvent('project-valuation-infobar-item-changed', (params) => {
      const mode = params.mode;
      const item = params.item;
      const itemIdentityProperty = params.itemIdentityProperty;

      const changeItem = (mode === this.mode) // same infobar mode
        && (
          // item not set yet
          !this.infobarItem[mode]
          ||
          // had item and new is null
          (this.infobarItem[mode] && item === null)
          ||
          // item changed
          (this.infobarItem[mode][itemIdentityProperty] !== item[itemIdentityProperty])
        );

      if (changeItem) {
        this.setMode(mode, item);
      }
    });
  }

  /**
   * Subscribes to infobar change event
   * */
  subscribeToProjectValuationInfobarChange() {
    this.eventBus.subscribeEvent('project-valuation-infobar-changed', (mode) => {
      const newInfoBarType = mode.params ? mode.params.infobarType : this.infobarType;

      this.infobarType = null;
      if (mode.areaChanged) {
        this.mode = 'none';
      }
      this.enableSettings = mode.enableSettings;
      this.infobarType = newInfoBarType;
    });
  }

  /**
   * On element selected action
   * @param tabItem Selected tab item
   * @param item Selected item
   */
  public onElementSelected(tabItem: TabConfig, item: any) {
    let mode = "none";
    switch (tabItem.id) {
      case "tabProperty": {
        mode = "property";
        const infobarItemChanged = (item !== this.infobarItem[mode]);
        this.setMode(mode, infobarItemChanged ? item : null);
        this.main.setPVInfoBarVisibility(infobarItemChanged, false, null, { infobarType: 'pictures' });
        break;
      }
      case "tabProjectstd":
        mode = "projectstd";
        this.infobarItem[this.mode] = null;
        this.handleInfobarVisibility(mode, item);
        break;
      case "tabReport":
        mode = "report";
        this.infobarItem[this.mode] = null;
        this.handleInfobarVisibility(mode, item);
        break;
      case "tabValuationPortfolio":
        mode = "valuationProject";
        this.infobarItem[this.mode] = null;
        this.handleInfobarVisibility(mode, item);
        break;
      default:
        this.setMode(mode, null);
        this.main.setPVInfoBarVisibility(false, true);
        break;
    }
  }

  /**
   * Handles infobar visibility
   * @param mode Infobar mode
   * @param item Selected item
   */
  handleInfobarVisibility(mode, item) {
    this.main.setPVInfoBarVisibility(this.main.getPVInfoBarVisibility(), true);
    this.setMode(mode, item);
    this.main.setPVInfoBarVisibility(this.main.getPVInfoBarVisibility(), false);
    this.setMode(mode, item);
  }

  /**
   * Sets the infobar mode and item
   * @param mode Infobar mode
   * @param item Infobar item
   */
  setMode(mode, item) {
    this.infobarItem[mode] = item;
    this.mode = mode;
  }

}
